import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router';
import { compose, withProps, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import * as SessionSelectors from '../../app/entities/Session/selectors';
import Notifications from '../../app/components/Notifications/Notifications';
import Home from '../routes/Home/Home';
import requireProps from '../../app/lib/requireProps';
import Routes from './Routes';
import Me from '../routes/Me/Me';
import TimeReport from '../routes/TimeReport/TimeReport';
import ReportedTimes from '../routes/ReportedTimes/ReportedTimes';
import Availabilities from '../routes/Availabilities/Availabilities';
import Areas from '../routes/Areas/Areas';
import Header from './Header';
import MySchedule from '../routes/MySchedule/MySchedule';
import Footer from './Footer';

function AuthenticatedContainer({ authenticated }) {
  if (!authenticated) {
    return null;
  }

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <Notifications />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/me" component={Me} />
          <Route path="/schedule" component={MySchedule} />
          <Route path="/timereport" component={TimeReport} />
          <Route path="/reported-times" component={ReportedTimes} />
          <Route path="/availabilities" component={Availabilities} />
          <Route path="/area-of-interest" component={Areas} />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

AuthenticatedContainer.propTypes = {
  authenticated: PropTypes.bool.isRequired,
};

const withAuthenticated = connect(
  state => ({ authenticated: SessionSelectors.authenticated(state) }),
);

export default compose(
  withAuthenticated,
  requireProps(['authenticated'], true, true),
  withProps(({ history, authenticated }) => ({
    ensureAuthentication: () => {
      if (!authenticated) {
        history.push(Routes.login());
      }
    },
  })),
  lifecycle({
    componentWillMount() {
      this.props.ensureAuthentication();
    },
    componentDidUpdate() {
      this.props.ensureAuthentication();
    },
  }),
)(AuthenticatedContainer);
